import { useCallback } from "react";
import { useSelector } from "react-redux";
import {EVENT_NAME_CHECKOUT_STEP_VIEWED} from "./constants";
import {trackAnalyticsEvent} from "./event";
import {
    getCurrentPaymentCartId,
    getPaymentPlatform,
    getPaymentRef
} from "../../store/payments/selectors";

export const useTrackCheckoutStepViewed = (step: number) => {
    const cartId = useSelector(getCurrentPaymentCartId);
    const platform = useSelector(getPaymentPlatform);
    const ref = useSelector(getPaymentRef);
    

    return useCallback(() => {
        trackAnalyticsEvent(EVENT_NAME_CHECKOUT_STEP_VIEWED, {
            step,
            checkout_id: `checkout-${cartId}`,
            order_id: cartId,
            cart_id: cartId,
            platform,
            payment_ref: ref,
        });
    }, [cartId, platform, ref, step]);
};
